export const ALL = '__all__'

// features
export const FEATURE_IMPORT_FROM_FILE = 'import_from_file'
